export const isReadOnlyFieldClickable = ({ field, rowData }) =>
	typeof field.onClick === 'function' &&
	(typeof field.isClickable !== 'function' || field.isClickable(rowData));
